import React, { useEffect, useState } from "react";
import reactRouterDom, { Link, useHistory } from "react-router-dom";
import { connect, useDispatch, useSelector } from "react-redux";
import toast from '../../shared/Toast';
// import '../service.css';
import Select from 'react-select';
import Tab from 'react-bootstrap/Tab';
import Tabs from 'react-bootstrap/Tabs';
import CancelSaveBtn from "./CancelSaveBtn";
import useWindowSize from "../useWindowSize";
import { newServicesAction } from "../../../_actions";
import InlinePickerSelect from '../../shared/InlinePickerSelect';
import { newServices } from "../../../_services/newservices.service";
import { formService } from "../../../_services/form.service";
import CatalogueTopNav from "../CatalogueTopNav";
import { normaliseImage } from '../../shared/normaliseImage';
import '../../forms/Forms.css';


function AddService(props) {
    const [serviceName, setServiceName] = useState('');
    const [category, setCategory] = useState(null);
    const [serviceTime,setServiceTime] =useState('')
    const [description, setDescription ] = useState("")
    const [defaultDiaryColour, setDefaultDiaryColour] = useState('#c8eeee'); // Default diary color (light cyan)
    const [errors, setErrors] = useState({}); // State for error messages
    // Image upload state - stores File objects and preview URLs
    const [pendingServiceImages, setPendingServiceImages] = useState([]); // Array of {file: File, preview: string}
    const [isSaving, setIsSaving] = useState(false);
    const dispatch = useDispatch();
    const history = useHistory();
    const { width } = useWindowSize();
    const listCategory = useSelector(state => state.newServices.listCategory);
    const listHairdresser = useSelector(state => state?.newServices?.listHairdresser);
    const user = useSelector(state => state.user);
    // Check if user is a salon manager based on the actual user data structure
    const isSalonManager = user?.userInfo?.hairdresser?.isSalonOwner === 1;
    const [staffSettings, setStaffSettings] = useState([]);
    // Available automatic forms (for linking to staff)
    const [availableAutoForms, setAvailableAutoForms] = useState([]);
    // Track which staff row has the form selector open
    const [formSelectorOpenIndex, setFormSelectorOpenIndex] = useState(null);
    // Track which staff member's detail panel is open (null = closed)
    const [selectedStaffIndex, setSelectedStaffIndex] = useState(null);
    // Tab navigation state
    const [activeTab, setActiveTab] = useState('detail');
const categoryOptions = listCategory?.map(category => ({
  value: category?._id, // Use '_id' for the value
  label: category?.categoryName // Use 'categoryName' for the label
}));

const customStyles = {
  control: (provided, state) => ({
    ...provided,
    border: state.isFocused ? '1px solid #007EA0' : '1px solid #e0e0e0',
    borderRadius: '10px',
    minHeight: '44px',
    boxShadow: state.isFocused ? '0 0 0 3px rgba(0, 126, 160, 0.08)' : 'none',
    background: '#fff',
    cursor: 'pointer',
    fontSize: '14px',
    transition: 'border-color 0.15s ease, box-shadow 0.15s ease',
    '&:hover': {
      borderColor: state.isFocused ? '#007EA0' : '#ccc',
    },
  }),
  indicatorSeparator: () => ({ display: 'none' }),
  dropdownIndicator: (provided) => ({
    ...provided,
    color: '#999',
    padding: '8px 10px',
    '&:hover': { color: '#666' },
  }),
  singleValue: (provided) => ({
    ...provided,
    fontSize: '14px',
    color: '#333',
  }),
  menu: (provided) => ({
    ...provided,
    borderRadius: '12px',
    border: '1px solid #e8e8e8',
    boxShadow: '0 8px 24px rgba(0, 0, 0, 0.1), 0 2px 8px rgba(0, 0, 0, 0.04)',
    overflow: 'hidden',
    zIndex: 20,
    marginTop: '4px',
  }),
  menuList: (provided) => ({
    ...provided,
    padding: '4px',
    maxHeight: '240px',
  }),
  option: (provided, state) => ({
    ...provided,
    backgroundColor: state.isSelected ? '#29282D' : state.isFocused ? '#f0f0f0' : '#fff',
    color: state.isSelected ? '#fff' : '#333',
    fontSize: '14px',
    padding: '10px 12px',
    borderRadius: '8px',
    cursor: 'pointer',
    transition: 'background 0.1s ease',
    '&:active': {
      backgroundColor: state.isSelected ? '#29282D' : '#e8e8e8',
    },
  }),
  placeholder: (provided) => ({
    ...provided,
    fontSize: '14px',
    color: '#aaa',
  }),
};

    const categoryList = () => {
        const payload = {}
        dispatch(newServicesAction.listCategoryData(payload))
            .then((res) => {
                console.log("Category list successfully:", res);

            })
            .catch((error) => {
                console.error("Error with category list:", error);
            });
    }

const handleStaffSettingChange = (index, field, value) => {
  console.log(" ", index, field, value);
  // debugger;

  if (field === "serviceTime"  && value !== 0) {
   
    const error = validateFields(field, value);
    setErrors(prev => ({
      ...prev,
      [`${field}_${index}`]: error // Use a unique key for each staff member's field
    }));
  } else if(field === "processingTime"  && value !== 0) {
   
    const error = validateFields(field, value);
    setErrors(prev => ({
      ...prev,
      [`${field}_${index}`]: error // Use a unique key for each staff member's field
    }));
  } else {
    // Clear the error if the field is valid or empty
    setErrors(prev => {
      const newErrors = { ...prev };
      delete newErrors[`${field}_${index}`];
      return newErrors;
    });
  }
  
  const newStaffSettings = [...staffSettings];
  
  // If changing diary color, mark it as overridden
  if (field === "diaryColour") {
    newStaffSettings[index][field] = value;
    newStaffSettings[index].isColourOverridden = true;
  } else {
    newStaffSettings[index][field] = value;
  }
  
  setStaffSettings(newStaffSettings);
};

// Handle default diary color change
const handleDefaultDiaryColourChange = (value) => {
  console.log("Default diary color changed to:", value);
  
  // Update the default color
  setDefaultDiaryColour(value);
  
  // Create completely new staff settings objects to avoid reference issues
  const newStaffSettings = staffSettings.map(staff => {
    // Create a new staff object
    const newStaff = { ...staff };
    
    // Only update if not manually overridden
    if (!newStaff.isColourOverridden) {
      newStaff.diaryColour = value;
      console.log(`Updated staff ${newStaff.name} color to ${value}`);
    } else {
      console.log(`Skipped staff ${newStaff.name} - color is overridden`);
    }
    
    return newStaff;
  });
  
  console.log("Updated staff settings:", newStaffSettings);
  
  // Update the state with the new staff settings
  setStaffSettings(newStaffSettings);
};

// Reset diary color to system default (#c8eeee)
const handleResetDiaryColour = () => {
  console.log("Reset to Default button clicked");
  const systemDefaultColor = '#c8eeee';
  
  console.log("Before reset - defaultDiaryColour:", defaultDiaryColour);
  
  // Reset the default color
  setDefaultDiaryColour(systemDefaultColor);
  
  // Reset ALL staff colors to the system default, regardless of override status
  const newStaffSettings = staffSettings.map(staff => ({
    ...staff,
    diaryColour: systemDefaultColor,
    isColourOverridden: false // Reset the override flag too
  }));
  
  console.log("After reset - new staff settings:", newStaffSettings);
  
  // Update the state with the new staff settings
  setStaffSettings(newStaffSettings);
};

// Handle adding a pending service image (stored locally until service is created)
const handleAddServiceImage = async (e) => {
  const picked = e.target.files[0];
  const inputElement = e.target;
  if (!picked) return;

  // iOS can leave the type blank for HEIC picks, so only refuse a
  // file that says it is something other than an image.
  if (picked.type && !picked.type.startsWith('image/')) {
    toast.error('Please select an image file');
    return;
  }

  // HEIC → JPEG and shrink to ~2048px (shared/normaliseImage). Modern
  // iPhone photos are often over 5MB and were refused outright before.
  const file = await normaliseImage(picked);
  if (file.size > 10 * 1024 * 1024) {
    toast.error('That image is too large. Please try another.');
    return;
  }
  
  // Create preview URL
  const preview = URL.createObjectURL(file);
  
  // Add to pending images
  setPendingServiceImages(prev => [...prev, { file, preview }]);
  
  // Reset file input
  if (inputElement) {
    inputElement.value = '';
  }
};

// Handle removing a pending service image
const handleRemoveServiceImage = (index) => {
  setPendingServiceImages(prev => {
    // Revoke the preview URL to free memory
    URL.revokeObjectURL(prev[index].preview);
    return prev.filter((_, i) => i !== index);
  });
};

// Upload pending images after service is created
const uploadPendingImages = async (commonServiceId) => {
  if (pendingServiceImages.length === 0) return;
  
  console.log(`Uploading ${pendingServiceImages.length} pending images for service ${commonServiceId}`);
  
  for (const imageData of pendingServiceImages) {
    const formData = new FormData();
    formData.append('serviceImage', imageData.file);
    formData.append('commonServiceId', commonServiceId);
    
    try {
      const res = await dispatch(newServicesAction.uploadServiceImageData(formData));
      if (res?.uploadServiceImage?.statusCode === 1) {
        console.log('Image uploaded successfully');
      } else {
        console.error('Failed to upload image:', res?.uploadServiceImage?.error?.responseMessage);
      }
    } catch (error) {
      console.error('Error uploading image:', error);
    }
    
    // Revoke preview URL
    URL.revokeObjectURL(imageData.preview);
  }
};

const validateFields = (name, value) => {
  // debugger
  //Deposit amount never greater than Service Cost ,it should equal but not greaterthan
  let error = '';
  switch (name) {
      case 'serviceName':
          if (!value) {
              error = "Service Name is required.";
          }
          break;
      case 'category':
          if (!value) {
              error = "Category is required.";
          }
          break;
      case 'serviceTime':
        if (value!=0 && value%5!=0) {
              error = "Must be multiple of 5.";
          }
          break;
      case 'processingTime':
          if (value!=0 && value%5!=0) {
              error = "Must be multiple of 5.";
          }
          break;
          
      default:
          break;
  }
  return error;
};

const handleChange = (e) => {
    const { name, value } = e.target;

    switch (name) {
        case 'serviceName':
            setServiceName(value);
            break;
        case 'description':
            setDescription(value);
            break;
        default:
            break;
    }

    setErrors(prev => ({
        ...prev,
        [name]: validateFields(name, value)
    }));
};

const handleCategoryChange = (selected) => {
    setCategory(selected);
    setErrors(prev => ({
        ...prev,
        category: validateFields('category', selected)
    }));
};

const listHairdresseData =()=>{
  let payload = { }
  dispatch(newServicesAction.listHairDresserData(payload))
    .then((res) => {
      console.log("Hairdresser data fetched successfully:", res?.listHairdresser);
      if (res?.listHairdresser) {
        const hairdresserList = res?.listHairdresser;
        const staffMembers = hairdresserList.map(hairdresser => ({
          name: hairdresser?.name,
          _id: hairdresser?._id,
          enabled: false
        }));

        // Update staffSettings with the new data
        setStaffSettings(staffMembers.map(staff => ({
          ...staff,
          isDeactivated: false,
          onlineBooking: false,
          serviceTime: '',
          processingTime: '',
          depositPrice: '',
          servicePrice: '',
          diaryColour: defaultDiaryColour, // Use default diary color
          isColourOverridden: false, // Track if color is manually overridden
          linkedForms: [] // Forms linked to this staff member's service
        })));
      }
    })
    .catch((error) => {
      console.error("Error edit category:", error);
    });
}

// const staffMembers = listHairdresser?.map(hairdresser => ({
//   name: hairdresser?.name,
//   _id:hairdresser?._id,
//   enabled: false
//   }))

// const [staffSettings, setStaffSettings] = useState(staffMembers?.map(staff => ({
//   ...staff,
//   isDeactivated:false,
//   onlineBooking: false,
//   serviceTime: '',
//   processingTime: '',
//   depositPrice: '',
//   servicePrice: ''
// })));

const handleSave = () => {
  
  setErrors({});
  
  const newErrors = {
      serviceName: validateFields('serviceName', serviceName),
      // serviceTime: validateFields('serviceTime', serviceTime),
      category   : validateFields('category', category)
  };
  
   if (staffSettings && Array.isArray(staffSettings)) {
    for (let index = 0; index < staffSettings.length; index++) {
      const staff = staffSettings[index];
      if (staff.isDeactivated == true && ( staff.serviceTime == '' || staff.serviceTime == 0)) {
        newErrors[`serviceTime_${index}`] = "Service time can't be set to 0 when service is enabled";
      } else if (staff.serviceTime) {
        const serviceTimeError = validateFields('serviceTime', parseInt(staff.serviceTime));
        if (serviceTimeError) {
          newErrors[`serviceTime_${index}`] = serviceTimeError;
        }
      }
      if (staff.processingTime) {
        const processingTimeError = validateFields('processingTime', parseInt(staff.processingTime));
        if (processingTimeError) {
          newErrors[`processingTime_${index}`] = processingTimeError;
        }
      }

      if (parseFloat(staff.depositPrice) > parseFloat(staff.servicePrice)) {
        newErrors[`depositPrice_${index}`] = "Deposit price cannot be greater than service price.";
      }
    }
  }
  

  const filteredErrors = Object.fromEntries(Object.entries(newErrors).filter(([_, v]) => v));
  setErrors(filteredErrors);

  if (Object.keys(filteredErrors).length > 0) {
      return; 
  }
  // debugger;
  // Log the current state before creating the payload
  console.log("Current defaultDiaryColour:", defaultDiaryColour);
  console.log("Current staffSettings:", staffSettings);
  
  // Ensure we have a valid default color
  const finalDefaultColor = defaultDiaryColour || '#c8eeee';
  
  // Ensure we have a valid default color for all staff members
  const payload = {
    serviceName,
    categoryID: category ? category.value: "",
    serviceDescription: description,
    diaryColour: finalDefaultColor, // Use diaryColour field for the default color
    // IMPORTANT: Set the top-level diaryColour for all staff members
    // This seems to be what makes the backend save colors for all staff
    hairdresserService: staffSettings.map((staff, index) => {
      // ALWAYS use the default color for all staff members unless explicitly overridden
      // This ensures all staff get a color even if they have no other settings
      const staffColor = staff.isColourOverridden && staff.diaryColour ?
                        staff.diaryColour :
                        finalDefaultColor;
      
      console.log(`Staff ${staff.name}: using color ${staffColor}, isOverridden=${staff.isColourOverridden}`);
      
      // Use the user's values for all staff members
      return {
        hairdresserId: staff._id,
        servicePrice: parseFloat(staff.servicePrice) || 0,
        serviceTime: parseFloat(staff.serviceTime) || 0,
        isDeactivated: !staff.isDeactivated,
        depositPrice: parseFloat(staff.depositPrice) || 0,
        onlineBooking: staff.onlineBooking || false,
        processingTime: parseFloat(staff.processingTime) || 0,
        // IMPORTANT: Always provide a non-empty color value
        diaryColour: staffColor || finalDefaultColor,
        // Use the staff member's original override setting
        isColourOverridden: staff.isColourOverridden || false,
        name: staff.name, // Include name to help with debugging
        linkedForms: (staff.linkedForms || []).map(f => ({
          formId: f.formId,
          formName: f.formName,
          isRequired: f.isRequired !== false
        }))
      };
    }),
  };
  
  console.log("Final payload:", payload);
  
  // Log the final payload
  console.log("Final payload:", payload);
  console.log("Saving add service data:", payload);
  setIsSaving(true);
  dispatch(newServicesAction.createServicesData(payload))
  .then(async (res) => {
    console.log("Service created successfully:", res);
    if(res?.newServices?.statusCode===1) {
      // Get the commonServiceId from the response
      const commonServiceId = res?.newServices?.responseData?.result?.[0]?.commonServiceId;
      
      // Upload pending images if any
      if (commonServiceId && pendingServiceImages.length > 0) {
        toast.info('Uploading images...');
        await uploadPendingImages(commonServiceId);
      }
      
      toast.success(res?.newServices?.responseData?.message || 'Service created successfully');
      history.push("/new-services");
    }
    else{
      toast.error(res?.newServices?.error?.responseMessage);
    }
  })
  .catch((error) => {
    console.error("Error creating service:", error);
    toast.error('Failed to create service');
  })
  .finally(() => {
    setIsSaving(false);
  });
  };

useEffect(()=>{
  listHairdresseData();
  categoryList();
  // Load automatic forms from API
  formService.listForms({ status: 'active', formType: 'automatic' })
    .then((response) => {
      const data = response.data?.responseData || {};
      setAvailableAutoForms(data.result || []);
    })
    .catch(() => setAvailableAutoForms([]));
  },[])

// --- Per-Staff Linked Forms Helpers ---
const handleAddStaffForm = (staffIndex, form) => {
  const fId = form._id || form.id;
  const newStaffSettings = [...staffSettings];
  const current = newStaffSettings[staffIndex].linkedForms || [];
  if (current.find(f => f.formId === fId)) return;
  newStaffSettings[staffIndex] = {
    ...newStaffSettings[staffIndex],
    linkedForms: [...current, { formId: fId, formName: form.name, isRequired: true }]
  };
  setStaffSettings(newStaffSettings);
  setFormSelectorOpenIndex(null);
};

const handleRemoveStaffForm = (staffIndex, formId) => {
  const newStaffSettings = [...staffSettings];
  newStaffSettings[staffIndex] = {
    ...newStaffSettings[staffIndex],
    linkedForms: (newStaffSettings[staffIndex].linkedForms || []).filter(f => f.formId !== formId)
  };
  setStaffSettings(newStaffSettings);
};

const renderServiceDetails = () => {
  const inputStyle = { width: '100%', padding: '10px 14px', border: '1px solid #e5e5e5', borderRadius: '10px', fontSize: '14px', outline: 'none', fontFamily: 'inherit' };
  const labelStyle = { fontSize: '14px', fontWeight: '600', color: '#1a1a1a', display: 'block', marginBottom: '8px' };

  // Compute diary colour display
  const uniqueColors = new Set();
  staffSettings.forEach(s => { if (s.diaryColour) uniqueColors.add(s.diaryColour); });
  const hasMultipleColors = uniqueColors.size > 1;
  let displayColor = defaultDiaryColour;
  if (uniqueColors.size === 1) displayColor = Array.from(uniqueColors)[0];
  else if (hasMultipleColors) displayColor = `linear-gradient(to right, ${Array.from(uniqueColors).join(', ')})`;

  return (
    <div style={{ backgroundColor: 'white', borderRadius: '12px', border: '1px solid #e5e5e5', padding: '24px', marginTop: '16px' }}>
      <h4 style={{ fontSize: '16px', fontWeight: '600', color: '#1a1a1a', margin: '0 0 24px 0' }}>Service Details</h4>

      <div style={{ display: 'flex', flexDirection: 'column', gap: '20px' }}>
        {/* Service Name */}
        <div>
          <label style={labelStyle}>Service Name</label>
          <input type="text" name="serviceName" placeholder="e.g. Haircut" value={serviceName} onChange={handleChange} style={inputStyle} />
          {errors.serviceName && <span className="cm_error_msg" style={{ fontSize: '12px' }}>{errors.serviceName}</span>}
        </div>
        {/* Category */}
        <div>
          <label style={labelStyle}>Category</label>
          <InlinePickerSelect
            options={categoryOptions}
            value={category}
            onChange={handleCategoryChange}
            onCreateNew={async (name) => {
              try {
                await newServices.createCategory({ categoryName: name });
                const res = await dispatch(newServicesAction.listCategoryData({}));
                toast.success('Category created');
              } catch { toast.error('Failed to create category'); throw new Error(); }
            }}
            placeholder="Choose a Category"
            createLabel="Create new category"
            searchPlaceholder="Search categories..."
            error={errors.category}
          />
        </div>
      </div>

      {/* Description */}
      <div style={{ marginTop: '20px' }}>
        <label style={labelStyle}>Service Description</label>
        <textarea name="description" placeholder="e.g. Transform your look with a professional haircut tailored to your style preferences..." value={description} onChange={handleChange} style={{ ...inputStyle, minHeight: '80px', resize: 'vertical' }} />
      </div>

      {/* Service Images */}
      {isSalonManager && (
        <div style={{ marginTop: '24px' }}>
          <label style={labelStyle}>Service Images</label>
          <div className="service-images-grid">
            {pendingServiceImages.map((imageData, index) => (
              <div key={index} className="service-images-item">
                <img src={imageData.preview} alt={`Service ${index + 1}`} className="service-images-image" />
                <button type="button" className="service-images-delete" onClick={() => handleRemoveServiceImage(index)} disabled={isSaving}>×</button>
              </div>
            ))}
            <div className={`service-images-upload ${isSaving ? 'uploading' : ''}`}>
              {isSaving ? <span>Saving...</span> : <><span className="upload-icon">+</span><span>Add Image</span></>}
              <input type="file" accept="image/*" onChange={handleAddServiceImage} disabled={isSaving} />
            </div>
          </div>
          <p style={{ fontSize: '12px', color: '#9ca3af', marginTop: '8px' }}>Max 5MB per image. JPG, PNG, GIF supported. Images will be uploaded when you save.</p>
        </div>
      )}

      {/* Diary Colour */}
      {isSalonManager && (
        <div style={{ marginTop: '24px' }}>
          <label style={labelStyle}>Set service colour for all staff</label>
          <div style={{ display: 'flex', alignItems: 'center', gap: '12px', marginTop: '8px' }}>
            <div style={{ width: '40px', height: '40px', borderRadius: '50%', background: displayColor, border: '1px solid #e5e5e5', position: 'relative', overflow: 'hidden', cursor: 'pointer', flexShrink: 0 }}>
              <input type="color" value={defaultDiaryColour} onChange={(e) => handleDefaultDiaryColourChange(e.target.value)} style={{ position: 'absolute', top: 0, left: 0, width: '100%', height: '100%', opacity: 0, cursor: 'pointer' }} />
            </div>
            <span style={{ fontSize: '14px', color: '#737373' }}>{hasMultipleColors ? 'Multiple colours' : 'Selected colour'}</span>
            <button type="button" onClick={handleResetDiaryColour} style={{ padding: '6px 14px', border: '1px solid #e5e5e5', borderRadius: '8px', background: 'white', fontSize: '13px', color: '#737373', cursor: 'pointer' }}>
              Reset to Default
            </button>
          </div>
          <p style={{ fontSize: '12px', color: '#9ca3af', marginTop: '8px' }}>Pick a light colour with good contrast for dark text.</p>
        </div>
      )}
    </div>
  );
};

const currencySymbol = user?.userInfo?.hairdresser?.currencySymbol || '£';

const renderStaffSettings = () => (
  <div style={{ backgroundColor: 'white', borderRadius: '12px', border: '1px solid #e5e5e5', marginTop: '16px', overflow: 'hidden' }}>
    <div>
      <table style={{ width: '100%', borderCollapse: 'collapse', minWidth: 0 }}>
        <thead>
          <tr style={{ backgroundColor: '#fafafa', borderBottom: '1px solid #e5e5e5' }}>
            <th style={{ textAlign: 'left', padding: '14px 20px', fontSize: '12px', fontWeight: '600', color: '#737373', textTransform: 'uppercase', letterSpacing: '0.05em' }}>Staff Member</th>
            <th style={{ textAlign: 'left', padding: '14px 20px', fontSize: '12px', fontWeight: '600', color: '#737373', textTransform: 'uppercase', letterSpacing: '0.05em' }}>Enabled</th>
            <th style={{ textAlign: 'left', padding: '14px 20px', fontSize: '12px', fontWeight: '600', color: '#737373', textTransform: 'uppercase', letterSpacing: '0.05em' }}>Duration</th>
            <th style={{ textAlign: 'right', padding: '14px 20px', fontSize: '12px', fontWeight: '600', color: '#737373', textTransform: 'uppercase', letterSpacing: '0.05em' }}>Price</th>
          </tr>
        </thead>
        <tbody>
          {staffSettings?.map((staff, index) => (
            <tr
              key={staff.name || staff._id}
              onClick={() => { console.log('Staff row clicked, index:', index); setSelectedStaffIndex(index); }}
              style={{
                borderBottom: index < staffSettings.length - 1 ? '1px solid #f0f0f0' : 'none',
                cursor: 'pointer',
                transition: 'background-color 0.1s'
              }}
              onMouseOver={(e) => e.currentTarget.style.backgroundColor = '#fafafa'}
              onMouseOut={(e) => e.currentTarget.style.backgroundColor = 'white'}
            >
              <td style={{ padding: '16px 20px' }}>
                <p style={{ fontSize: '14px', fontWeight: '500', color: '#1a1a1a', margin: 0 }}>{staff.name}</p>
                {(staff.linkedForms || []).length > 0 && (
                  <p style={{ fontSize: '11px', color: '#9ca3af', margin: '2px 0 0 0' }}>
                    {staff.linkedForms.length} form{staff.linkedForms.length !== 1 ? 's' : ''} linked
                  </p>
                )}
              </td>
              <td style={{ padding: '16px 20px' }}>
                <div className="salon_switch_container" style={{ display: 'inline-block' }} onClick={(e) => e.stopPropagation()}>
                  <label className="switch">
                    <input
                      type="checkbox"
                      onChange={(e) => handleStaffSettingChange(index, 'isDeactivated', e.target.checked)}
                      checked={staff.isDeactivated}
                    />
                    <span className="slider round"></span>
                  </label>
                </div>
              </td>
              <td style={{ padding: '16px 20px' }}>
                <p style={{ fontSize: '14px', color: '#4b5563', margin: 0 }}>
                  {staff.serviceTime ? `${staff.serviceTime} min` : '-'}
                </p>
              </td>
              <td style={{ padding: '16px 20px', textAlign: 'right' }}>
                <p style={{ fontSize: '14px', fontWeight: '600', color: '#1a1a1a', margin: 0 }}>
                  {staff.servicePrice ? `${currencySymbol}${parseFloat(staff.servicePrice).toFixed(2)}` : '-'}
                </p>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
      {staffSettings?.length === 0 && (
        <div style={{ padding: '48px', textAlign: 'center' }}>
          <p style={{ fontSize: '14px', color: '#737373' }}>No staff members found</p>
        </div>
      )}
    </div>
  </div>
);

const renderStaffDetailPanel = () => {
  console.log('renderStaffDetailPanel called, selectedStaffIndex:', selectedStaffIndex);
  if (selectedStaffIndex === null || !staffSettings[selectedStaffIndex]) return null;
  const staff = staffSettings[selectedStaffIndex];
  const index = selectedStaffIndex;

  return (
    <>
      {/* Overlay */}
      <div
        style={{ position: 'fixed', inset: 0, backgroundColor: 'rgba(0, 0, 0, 0.3)', zIndex: 100000 }}
        onClick={() => { setSelectedStaffIndex(null); setFormSelectorOpenIndex(null); }}
      />
      {/* Panel */}
      <div style={{
        position: 'fixed', top: 0, right: 0, bottom: 0, width: '480px',
        backgroundColor: 'white', boxShadow: '-4px 0 20px rgba(0, 0, 0, 0.1)',
        zIndex: 100001, display: 'flex', flexDirection: 'column', maxWidth: '100vw'
      }}>
        {/* Header */}
        <div style={{ padding: '20px 24px', borderBottom: '1px solid #e5e5e5', display: 'flex', alignItems: 'center', gap: '12px' }}>
          <button
            onClick={() => { setSelectedStaffIndex(null); setFormSelectorOpenIndex(null); }}
            style={{ padding: '8px', border: 'none', background: 'none', cursor: 'pointer', display: 'flex', alignItems: 'center' }}
          >
            <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="#1a1a1a" strokeWidth="2"><path d="M15 18l-6-6 6-6"/></svg>
          </button>
          <div>
            <h2 style={{ fontSize: '18px', fontWeight: '600', color: '#1a1a1a', margin: 0 }}>Staff Service Settings</h2>
            <span style={{ fontSize: '13px', color: '#737373' }}>{staff.name}</span>
          </div>
        </div>

        {/* Content */}
        <div style={{ flex: 1, overflow: 'auto', padding: '24px' }}>
          {/* Service Enabled */}
          <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '24px' }}>
            <span style={{ fontSize: '14px', color: '#737373' }}>Service Enabled</span>
            <div className="salon_switch_container">
              <label className="switch">
                <input type="checkbox" onChange={(e) => handleStaffSettingChange(index, 'isDeactivated', e.target.checked)} checked={staff.isDeactivated} />
                <span className="slider round"></span>
              </label>
            </div>
          </div>

          {/* Online Bookings */}
          <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '24px' }}>
            <span style={{ fontSize: '14px', color: '#737373' }}>Online Bookings</span>
            <div className="salon_switch_container">
              <label className="switch">
                <input type="checkbox" onChange={(e) => handleStaffSettingChange(index, 'onlineBooking', e.target.checked)} checked={staff.onlineBooking} />
                <span className="slider round"></span>
              </label>
            </div>
          </div>

          {/* Divider */}
          <div style={{ borderTop: '1px solid #f0f0f0', margin: '8px 0 24px' }} />

          {/* Service Duration */}
          <div style={{ marginBottom: '20px' }}>
            <label style={{ fontSize: '14px', color: '#737373', display: 'block', marginBottom: '8px' }}>Service Duration (min)</label>
            <input
              type="number"
              value={staff.serviceTime}
              onChange={(e) => handleStaffSettingChange(index, 'serviceTime', e.target.value)}
              style={{ width: '100%', padding: '10px 14px', border: '1px solid #e5e5e5', borderRadius: '10px', fontSize: '14px', outline: 'none' }}
            />
            {errors[`serviceTime_${index}`] && <span className="cm_error_msg" style={{ fontSize: '12px' }}>{errors[`serviceTime_${index}`]}</span>}
          </div>

          {/* Processing Time */}
          <div style={{ marginBottom: '20px' }}>
            <label style={{ fontSize: '14px', color: '#737373', display: 'block', marginBottom: '8px' }}>Processing Time (min)</label>
            <input
              type="number"
              value={staff.processingTime}
              onChange={(e) => handleStaffSettingChange(index, 'processingTime', e.target.value)}
              style={{ width: '100%', padding: '10px 14px', border: '1px solid #e5e5e5', borderRadius: '10px', fontSize: '14px', outline: 'none' }}
            />
            {errors[`processingTime_${index}`] && <span className="cm_error_msg" style={{ fontSize: '12px' }}>{errors[`processingTime_${index}`]}</span>}
          </div>

          {/* Deposit */}
          <div style={{ marginBottom: '20px' }}>
            <label style={{ fontSize: '14px', color: '#737373', display: 'block', marginBottom: '8px' }}>Deposit ({currencySymbol})</label>
            <input
              type="number"
              value={staff.depositPrice}
              onChange={(e) => handleStaffSettingChange(index, 'depositPrice', e.target.value)}
              style={{ width: '100%', padding: '10px 14px', border: '1px solid #e5e5e5', borderRadius: '10px', fontSize: '14px', outline: 'none' }}
            />
            {errors[`depositPrice_${index}`] && <span className="cm_error_msg" style={{ fontSize: '12px' }}>{errors[`depositPrice_${index}`]}</span>}
          </div>

          {/* Service Cost */}
          <div style={{ marginBottom: '20px' }}>
            <label style={{ fontSize: '14px', color: '#737373', display: 'block', marginBottom: '8px' }}>Service Cost ({currencySymbol})</label>
            <input
              type="number"
              value={staff.servicePrice}
              onChange={(e) => handleStaffSettingChange(index, 'servicePrice', e.target.value)}
              style={{ width: '100%', padding: '10px 14px', border: '1px solid #e5e5e5', borderRadius: '10px', fontSize: '14px', outline: 'none' }}
            />
          </div>

          {/* Divider */}
          <div style={{ borderTop: '1px solid #f0f0f0', margin: '8px 0 24px' }} />

          {/* Diary Colour */}
          <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '24px' }}>
            <span style={{ fontSize: '14px', color: '#737373' }}>Diary Colour</span>
            <div style={{
              width: '40px', height: '40px', borderRadius: '50%',
              background: staff.diaryColour || '#c8eeee', border: '1px solid #ccc',
              position: 'relative', overflow: 'hidden', cursor: 'pointer'
            }}>
              <input
                type="color"
                value={staff.diaryColour || '#c8eeee'}
                onChange={(e) => handleStaffSettingChange(index, 'diaryColour', e.target.value)}
                style={{ position: 'absolute', top: 0, left: 0, width: '100%', height: '100%', opacity: 0, cursor: 'pointer' }}
              />
            </div>
          </div>

          {/* Divider */}
          <div style={{ borderTop: '1px solid #f0f0f0', margin: '8px 0 24px' }} />

          {/* Linked Forms */}
          <div style={{ marginBottom: '20px' }}>
            <label style={{ fontSize: '14px', fontWeight: '600', color: '#1a1a1a', display: 'block', marginBottom: '12px' }}>Linked Forms</label>
            <div className="staff-forms-cell" style={{ flexDirection: 'column', alignItems: 'stretch', gap: '8px', position: 'relative' }}>
              {(staff.linkedForms || []).map((lf) => (
                <div key={lf.formId} style={{
                  display: 'flex', alignItems: 'center', justifyContent: 'space-between',
                  padding: '10px 14px', background: '#f0f7fa', border: '1px solid #d0e8f0',
                  borderRadius: '8px', fontSize: '13px', color: '#1a1a1a'
                }}>
                  <span>{lf.formName}</span>
                  <button
                    type="button"
                    onClick={() => handleRemoveStaffForm(index, lf.formId)}
                    style={{
                      background: 'none', border: 'none', cursor: 'pointer', color: '#999',
                      fontSize: '18px', padding: '0 0 0 8px', lineHeight: 1
                    }}
                  >×</button>
                </div>
              ))}
              {formSelectorOpenIndex === index ? (
                <div style={{
                  border: '1px solid #e5e5e5', borderRadius: '10px', overflow: 'hidden',
                  background: '#fff', boxShadow: '0 4px 16px rgba(0,0,0,0.08)'
                }}>
                  {availableAutoForms
                    .filter(f => !(staff.linkedForms || []).find(lf => lf.formId === (f._id || f.id)))
                    .length > 0 ? (
                    availableAutoForms
                      .filter(f => !(staff.linkedForms || []).find(lf => lf.formId === (f._id || f.id)))
                      .map((form) => (
                        <div
                          key={form._id || form.id}
                          onClick={() => handleAddStaffForm(index, form)}
                          style={{ padding: '10px 14px', fontSize: '13px', color: '#333', cursor: 'pointer', borderBottom: '1px solid #f5f5f5' }}
                          onMouseOver={(e) => e.currentTarget.style.backgroundColor = '#f5f5f5'}
                          onMouseOut={(e) => e.currentTarget.style.backgroundColor = 'white'}
                        >
                          {form.name}
                        </div>
                      ))
                  ) : (
                    <div style={{ padding: '10px 14px', fontSize: '13px', color: '#999' }}>No forms available</div>
                  )}
                  <div
                    onClick={() => setFormSelectorOpenIndex(null)}
                    style={{ padding: '10px 14px', fontSize: '13px', color: '#999', borderTop: '1px solid #eee', cursor: 'pointer', textAlign: 'center' }}
                  >Close</div>
                </div>
              ) : (
                <button
                  type="button"
                  onClick={() => setFormSelectorOpenIndex(index)}
                  style={{
                    display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '8px',
                    width: '100%', padding: '10px', border: '2px dashed #d1d5db', borderRadius: '10px',
                    background: 'transparent', color: '#666', fontSize: '13px', fontWeight: '500', cursor: 'pointer'
                  }}
                >
                  + Add Form
                </button>
              )}
            </div>
          </div>
        </div>

        {/* Footer */}
        <div style={{ padding: '20px 24px', borderTop: '1px solid #e5e5e5' }}>
          <button
            onClick={() => { setSelectedStaffIndex(null); setFormSelectorOpenIndex(null); }}
            style={{
              width: '100%', padding: '12px', backgroundColor: '#1a1a1a', color: 'white',
              border: 'none', borderRadius: '10px', fontSize: '14px', fontWeight: '500', cursor: 'pointer'
            }}
          >
            Done
          </button>
        </div>
      </div>
    </>
  );
};
 
return (
  <>
  <div className="h_n _new__service catalogue-no-header">
    <div className="body_container cm_bg_white">
      <div className="catalogue-page-wrapper">
        <CatalogueTopNav>
          <button
            type="button"
            className="catalogue-add-btn"
            onClick={handleSave}
            disabled={isSaving}
          >
            {isSaving ? 'Saving...' : 'Save'}
          </button>
        </CatalogueTopNav>
        <div className="catalogue-content-container">
          <div className="catalogue-content-wrapper">
            {/* Tab Navigation */}
            <nav style={{ display: 'flex', alignItems: 'center', gap: '0.5rem', borderBottom: '1px solid #e5e5e5', marginBottom: '24px' }}>
              {[{ id: 'detail', label: 'Detail' }, { id: 'team', label: 'Team' }].map(tab => (
                <button
                  key={tab.id}
                  type="button"
                  onClick={() => setActiveTab(tab.id)}
                  className={`catalogue-tab-btn ${activeTab === tab.id ? 'active' : ''}`}
                >
                  <span>{tab.label}</span>
                </button>
              ))}
            </nav>

            {/* Tab Content */}
            {activeTab === 'detail' && renderServiceDetails()}
            {activeTab === 'team' && renderStaffSettings()}
            <div style={{ height: '24px' }} />
          </div>
        </div>
      </div>
    </div>
  </div>

  {/* Staff Detail Sidebar Panel */}
  {renderStaffDetailPanel()}
  </>
)
}

export default AddService